import React from "react";
import "./Contact.css";
import { TranslationContext } from "../TranslationContext";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons/faEnvelope";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

function Contact() {
  const { translation } = React.useContext(TranslationContext);
  return (
    <div className="contact-container">
      <div className="contact-text-container">
        <h1 className="h1-contact">{translation.contactUs}</h1>
<div> <p className="p-colabora">{translation.colabora}</p></div>
        <div className="informations">
          

          <div className="contact-element">
            <FontAwesomeIcon className="icon" icon={faEnvelope} />{" "}
            <a href="mailto:detallitoslasnieves@outlook.es">
              detallitoslasnieves@outlook.es
            </a>
          </div>
          <div className="contact-element">
            <FontAwesomeIcon className="icon" icon={faLocationDot} />
            
            <p><a href="https://www.google.cz/maps/place/Barrio+Nieves,+2,+38700+Las+Nieves,+Santa+Cruz+de+Tenerife/@28.6943947,-17.7842949,17z/data=!3m1!4b1!4m6!3m5!1s0xc6beea36365060f:0x92cce2a1723306ae!8m2!3d28.69439!4d-17.78172!16s%2Fg%2F11c5jf_jt1?hl=en&entry=ttu&g_ep=EgoyMDI0MTEyNC4xIKXMDSoJLDEwMjExMjM0SAFQAw%3D%3D">Carretera las Nieves, 17, 38700 Santa Cruz de la Palma, Santa Cruz de Tenerife, Spain</a></p>
         
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
